import { z } from "zod/v4";

import { BaseIntegrationDtoSchema } from "../../../dtos/integrations";

export const GetIntegrationsRequestPathParamsSchema = z.object({
  integrationId: z.string().optional(),
});

export const GetIntegrationResponseBodySchema = z.object({
  integrations: BaseIntegrationDtoSchema.array(),
});

export type GetIntegrationRequestPathParamsType = z.infer<
  typeof GetIntegrationsRequestPathParamsSchema
>;

export type GetIntegrationResponseBodyType = z.infer<
  typeof GetIntegrationResponseBodySchema
>;
